import React from 'react';
import PropTypes from 'prop-types';

import { setLocalStorage } from '@helpers/local_storage';

const ExpandSidebarButton = ({ setCollapsed }) => {
  const handleToggle = () => {
    setCollapsed((prevState) => {
      setLocalStorage('assetModalAttachmentsSidebarCollapsed', JSON.stringify(!prevState));
      BF.fx.dispatchWindowEvent('updateSidebarCollapsed', null, { isCollapsed: !prevState });
      return !prevState;
    });
  };

  return (
    <button
      className="expand-sidebar-button"
      onClick={handleToggle}
      type="button"
    >
      <span className="bff-right-arrow" />
      <span className="bff-left-arrow" />
    </button>
  );
};

ExpandSidebarButton.propTypes = {
  setCollapsed: PropTypes.func.isRequired,
};

export default ExpandSidebarButton;
